import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-framer', 'IconBrandFramer', [
  ['path', { d: 'M6 15h12l-12 -12h12v6h-12v6l6 6v-6', key: 'svg-0' }],
]);
